import { BottomTabNavigationOptions } from "@react-navigation/bottom-tabs";
import { IconType } from "react-icons/lib";

const asTabBarIcon =
  (Icon: IconType): NonNullable<BottomTabNavigationOptions["tabBarIcon"]> =>
  // eslint-disable-next-line react/function-component-definition
  ({ color, size }) =>
    <Icon {...{ color, size }} />;

export default asTabBarIcon;
